export const text = {
  profilePicture: "Profile Picture",
  basicInfo: "Basic Information",
  selectCountry: "Select Country",
  selectState: "Select State",
  enterCityName: "Enter City Name",
  enterEmail: "Enter Email",
  enterFullName: "Enter Full Name",
  enterLastName: "Enter Last Name",
  enterMiddleName: "Enter Middle Name",
  enterFirstName: "Enter First Name",
  firstNameLabel: "First Name",
  middleNameLabel: "Middle Name",
  lastNameLabel: "Last Name",
  fullNameLabel: "Full Name",
  relationLabel: "Relation",
  emailLabel: "Email",
  phoneLabel: "Phone",
  genderLabel: "Gender",
  addressLabel: "Address",
  cityLabel: "City",
  stateLabel: "State",
  zipCodeLabel: "Zip Code",
  profileLinkLabel: "Profile Link",
  firstName: "First Name",
  lastName: "Last Name",
  middleName: "Middle Name",
  fatherName: "Father's Name",
  motherName: "Mother's Name",
  commentsLabel: "Comments",
  enterFatherName: "Enter Father Name",
  enterMotherName: "Enter Mother Name",
  enterProfileLink: "Enter Profile Link",
  siblingName: "Sibling Name",
  children: "Children Name",
  selectBirthDate: "Select Birth Date",
  birthDate: "Date of Birth",
  birthCity: "Birth City",
  birthState: "Birth State",
  EnterBirthCity: "Enter Birth City",
  selectDeathDate: "Select Death Date",
  selectRelation: "Select Relation",
  selectGender: "Select Gender",
  deathDate: "Date of Death",
  deathCity: "Death City",
  deathState: "Death State",
  EnterDeathCity: "Enter Death City",
  dateOfMarriage: "Date of Marriage",
  spouseName: "Spouse Name",
  EnterSpouseName: "Enter Spouse Name",
  childrenName: "Children Name",
  EnterChildrenName: "Enter Children Name",
  myBio: "Mini Bio",
  typeHere: "Type Here",
  socialMediaLink: "Social Media Link",
  instagram: "Instagram",
  facebook: "Facebook",
  twitter: "Twitter",
  description: "Description",
  timelineTitle: "Timeline Title",
  createTimeline: "Create Timeline",
  date: "Date",
  createAlbums: "Create Albums",
  JustDragAndDropForSeamlessSimplicity:
    "Just drag and drop for seamless simplicity",
  enterTitle: "Enter Title",
  addComment: "Add Comment",
  addDetails: "Add Details",
  advanceSearch: "Advance Search",
  byName: "By Name",
  byLife: "By Life",
  byRestingPlace: "By Resting Place",
  comment: "Comment",
  uploadPicturePDF: "Upload file",
  miniBio: "Mini Bio",
  birthDetails: "Birth Details",
  deathDetails: "Death Details",
  birthCountry: "Birth Country",
  marriageDetails: "Marriage Details",
  maritalStatus: "Marriage Status",
  deathCountry: "Death Country",
  enterAlbumName: "Enter Album Name",
  albumName: "Album Name",
  selectDate: "Select Date",
  familyTree: "Family Tree",
  addPermission: "Add Permission",
  addMember: "Add Member",
  memorialViewPermission: "Memorial View Permission",
  memorialEditPermission: "Memorial Edit Permission",
  deleteMemberText: "You want to delete this member",
  createdTimeline: "Created Timeline",
  capturedMemories: "Captured Memories",
  photoVideo: "Photographs- Videos- Other Media",
  createAMemorials: "Create A Memorial",
  selectMarriageDate: "Select Marriage Date",
  pinLocation: "Memorial Pin Location",
  pinLocationTooltip:
    "The pinned location will be useful when a user searches for your biography by location.",
};
